export default (theme) => ({
  productRelatedProducts: {
    position: "relative",
    padding: "50px 0",
    [theme.breakpoints.up("md")]: {
      padding: "100px 0 72px",
    },
    "&::before": {
      backgroundColor: theme.palette.secondary.main + "0A",
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: "50%",
      width: "100vw",
      transform: "translateX(-50%)",
      zIndex: -1,
    },
    "& h4": {
      marginBottom: 32,
    },
    "& .MuiGrid-grid-lg-4": {
      [theme.breakpoints.up("lg")]: {
        flex: "0 0 25% !important",
        maxWidth: "25% !important",
      },
    },
  },
});
